import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TopicService } from '../topic.service';
import { GeneralExerciseComponent } from '../../General/g-exercise.component';
import { NumberCardsService } from '../number-cards.service';
import { Location } from '@angular/common';
import { SuperExerciseComponent } from '../super-exercise/super-exercise.component';
import { MessageService } from '../../shared/message.service';

@Component({
  selector: 'app-number-cards',
  templateUrl: './number-cards.component.html',
  styleUrls: ['../topic-style.css', './number-cards.component.css']
})
export class NumberCardsComponent extends SuperExerciseComponent {

  //typespecs
  public showColoring: Boolean;
  private visualRepresentation: string;

  private digits: number[] = [];

  constructor(protected numberCardsService: NumberCardsService, protected activatedRoute: ActivatedRoute, protected topicService: TopicService, protected messageService: MessageService) {
    super(numberCardsService, activatedRoute, topicService, messageService);
  }

  /** set the typespecific information based on the configuration*/
  setTypeSpecificsFromConfiguration() {
    super.setTypeSpecificsFromConfiguration();
    let typespecs = this.configuration["typespecifics"];
    this.requestedNumber = typespecs["requestedNumber"];
    this.count = this.numberCardsService.getCount(this.cards);
    this.solution = this.numberCardsService.getSolution(this.requestedNumber, this.cards);
    this.showColoring = this.configuration.typespecifics.showColoring && this.representation == "nary" && this.configuration.typespecifics.representationSpec == 10;
    if (this.showColoring) {
      this.digits = [];
      let sNumber = this.requestedNumber.toString();
      for (var i = 0, len = sNumber.length; i < len; i += 1) {
        this.digits.push(+sNumber.charAt(i));
      }
    }
  }

  /** adds a card of the given value 
   * @param {number} card - value of card to add
  */
  addedCard(card: number): void {
    this.count[card]++;
  }

  /** removes a card of the given value 
   * @param {number} card - value of card to remove
  */
  removeCard(card: number): void {
    this.count[card]--;
  }

  /** checks, whether the solution is correct or not */
  checkSolution(): void {
    let error = false;
    this.error = [];
    this.feedback = "";
    let value = this.numberCardsService.getValue(this.count)
    if (value != this.numberCardsService.getValue(this.solution) && this.showHelptext) {
      this.feedback = this.get("hasValue").concat(value.toString(), ". ");
    }
    for (let i = 0; i < this.cards.length; i++) {
      if (this.solution[i] != this.count[this.cards[i]]) {
        error = true;
        if (this.showSymbols) {
          this.error.push(this.cards[i]);
        }
        if (this.showHelptext) {
          if (this.solution[i] > this.count[this.cards[i]]) {
            this.feedback = this.feedback.concat(this.get("tooFewCards"), " ", (new Number(this.cards[i])).toString(10), "\n");
          } else {
            this.feedback = this.feedback.concat(this.get("tooManyCards"), " ", (new Number(this.cards[i])).toString(), "\n");
          }
        }
      }
    }
    if (error) {
      this.messageService.addAlertWithTimeout(this.get("wrongAnswer").concat("\n", this.feedback.toString()), "danger", 10000);
    } else {
      this.messageService.addAlertWithTimeout(this.get("correct"), "success", 10000);
      this.solved = true;
      this.state.solved = true;
      this.saveState();
    }
  }

  /** returns a color based on the index
   * @param index - position to color
   */
  getColor(index: number): string {
    switch (index) {
      case 0: return "green";
      case 1: return "hotpink";
      case 2: return "mediumblue";
      case 3: return "orange";
      case 4: return "MidnightBlue";
    }
  }

  /** evaluates the current state of the exercise 
   * @returns {number} - returns the total number of points (unweigthed, the maximum is 1)
  */
  evaluate(): number[] {
    let result = 0;
    if (this.numberCardsService.getValue(this.count) == this.requestedNumber) {
      result = 0.5;
    }
    
    let error = false;
    for (let i = 0; i < this.cards.length; i++) {
      if (this.solution[i] != this.count[this.cards[i]]) {
        error = true;
      }
    }
    if (!error) {
      result += 0.5;
    }
    return [2*result,2];
  }
}